import React from "react";
import {Button, Form, Modal} from "react-bootstrap";
import {useDispatch} from "react-redux";
import {resetPasswordRequest} from "../actions/registeredUserAction";

/**
 * A modal dialog that will pop up an "are you sure" message when the admin tries to
 * force a claim.
 *
 * @param show - Boolean state indicating if the modal should be displayed
 * @param handleCancel - Function to call when the user clicks the "Cancel" button
 * @param handleProceed - Function to call when the user clicks the "Request" button
 * @returns {Element} - A modal dialog to display
 * @constructor
 */
const RegResetPasswordRequestOverlay = ({ show, handleCancel }) => {

  const [email, setEmail] = React.useState("");
  const [responseMessage, setResponseMessage] = React.useState(null);
  const [processing, setProcessing] = React.useState(false);
  const dispatch = useDispatch();

  const handleProceed = async () => {
    // Validate email format
    try {
      // Indicate that we are processing the request
      setProcessing(true);

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email)) {
        alert("Please enter a valid email address.");
        return;
      }

      // Proceed with password reset request logic
      const result = await dispatch(resetPasswordRequest(email));

      if(result.success) {
        setResponseMessage(result.data);
      }
      else {
        setResponseMessage(result?.error?.message || "Unable to reset your password at this time");
      }
    } catch (error) {
      setResponseMessage("Unable to reset your password at this time");
    } finally {
      setProcessing(false);
    }
  }

  const handleOverlayClose = () => {
    setEmail("");
    setResponseMessage("");
    setProcessing(false);
    handleCancel();
  }

  return (
    <>
      <Modal show={show} onHide={handleCancel} closebutton size="lg" centered backdrop="static">
        <Modal.Header>
          <div className="admin-modal-header">Password Reset Request</div>
        </Modal.Header>
        <Modal.Body>
          <div className="admin-modal-body">
            {responseMessage ? (
              <div className="gcotg-info-message">
                <div role="alert">{responseMessage}</div>
              </div>
            ) : (
              <div className="form-group gcotg-form-group">
                <label htmlFor="username">Enter the email address associated with your account</label>
                <Form.Control
                  type="text"
                  className="form-control gcotg-form-element"
                  name="email address"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" && !processing) {
                      handleProceed();
                    }
                  }}
                />
              </div>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer className="admin-modal-footer">
          {responseMessage ? (
            <Button className="btn btn-primary gcotg-button gcotg-button-centered" onClick={handleOverlayClose}>
              Close
            </Button>
          ) : (
            <>
              <Button className="btn btn-primary gcotg-button admin-modal-cancel-button" onClick={handleOverlayClose}>
                Cancel
              </Button>
              <Button className="btn btn-primary gcotg-button-secondary admin-modal-proceed-button"
                      disabled={processing}
                      onClick={handleProceed}>
                Reset Password
              </Button>
            </>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default RegResetPasswordRequestOverlay;
